import { XIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Close = (props: IconProps) => {
  const { size = 'md', ...rest } = props;

  return <XIcon {...rest} size={Sizes[size]} />;
};

Close.displayName = 'Close';
